import '../../scss/pages/contact.scss';

const winHeight = window.innerHeight;
const navbar = document.querySelector('.navbar-custom');
const contactContainer = document.querySelector('.contact');

const contactBannerContainer = document.querySelector('.contact-banner');

function getContactPaddingTop () {
    const navbarHeight = navbar.offsetHeight;
    let paddingTop = navbarHeight
    contactContainer.style.paddingTop = `${paddingTop}px` 
}

function getContactBannerHeight() {
    const navbarHeight = navbar.offsetHeight;
    let height = winHeight - navbarHeight
    if ( window.innerWidth >= 1200 ) {
        contactBannerContainer.style.height = `${height}px`
    } else {
        contactBannerContainer.style.height = `auto`
    }
}

document.addEventListener('DOMContentLoaded', () => {
    getContactPaddingTop()
    getContactBannerHeight()
})

window.addEventListener('load', () => {

})

window.addEventListener('resize', () => {
    getContactPaddingTop()
    getContactBannerHeight()
})